import {LANGUAGE} from '@/common/utils/constants';

export const NOTIFICATION_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		statuses: {
			"1": "New Submissions",
			"2": "Assigned",
			"3": "Under Review",
			"4": "CM Validation",
			"5": "RO Approval",
			"7": "Ready to Publish",
			"8": "Published"
		},
		emailExists: 'Email already exist',
		maxDraftStories: 'You have reached the maximum of 25 draft stories.',
		maxArchivedStories: 'You have reached the maximum of 25 archived stories.',
		loginFailed: "Incorrect email or password",
		serverError: "There was an error. Please try again later or send us feedback.",
		draftSuccessfulSaved: "The project is saved.",
		addToSaved: "The project has been saved successfully.",
		failedAddToSaved: "Failed to add the project to Saved Projects.",
		removeFromSaved: "The project has been removed successfully.",
		failedToRemoveFromSavedProjects: "Failed to remove the project from Saved Projects.",
		successfullyDownload: "The project is successfully downloaded.",
		successfullyCopyToClipboard: "Project content was copied successfully",
		failedCopyToClipboard: "Failed to copy project content to clipboard",
		successfullyReportedProblem: "Report has been sent successfully.",
		successfullySharedIdea: "The idea has been sent successfully.",
		reportIdea: "Report idea",
		reportAIdeaDescription: 'Please describe the idea. Our team will review it as soon as possible.',
		successfullyValidated: "The project is validated in ",
		newProjectStep: "The project is now in status -",
		projectWaitingForApproval: "Your project is waiting for your approval.",
		projectPublished: "Your project has been published.",
		successSubmit: "The project is submitted.",
		denialMessage: "The project is successfully denied.",
		approveProject: "The project is successfully approved.",
		reportAProblemValidation: "You haven’t written anything. Please write a message before sending.",
		reportAProblemPlaceholder: "Write your message here...",
		reportAProblemSend: "Send",
		reportAProblemSending: "Sending...",
		error: 'Something went wrong. Please try again later.',
		successUnarchived: 'The project was unarchived successfully.',
		successInvalidate: 'The project was invalidated successfully.',
		youDoNotHavePermissions: 'You don\'t have permission to unarchive projects which were with status Drafts.',
		reload: 'Successfully updated application version.',
		successBackToDraft: "Successfully returned to draft projects.",
		successUnpublished: "The project was unpublished successfully",
		successDeleted: "The project was deleted successfully",
		successDeletedRecognition: "Successfully deleted recognition",
		successDeletedOffer: "Successfully deleted offer",
		successDeletedSector: "Successfully deleted Industry Presentation",
		successArchiveOffer: "Successfully archived offer",
		successArchiveRecognition: "Successfully archived recognition",
		successUnArchiveOffer: "Successfully unarchived offer",
		successUnArchiveRecognition: "Successfully unarchived recognition",
		successUnArchiveSector: "Successfully unarchived sector-presentation",
		successArchiveSector: "Successfully archived sector-presentation",
		projectStepWasChanged: "Project step was changed",
		projectCannotBePreviewedBecauseValidations: "The project can’t be previewed because some of the validations don’t pass",
		emailSuccesfullyResent: "You have successfully resent an email for project",
		projectSuccessfullyAssigned: 'Project successfully assigned',
		failedToResendEmail: "Failed to resend an email for project with id",
		successArchived: 'The project was archived successfully.',
		successUploadImage: `The image was uploaded successfully.`,
		successUpdatedNotificationOrder: 'The order was updated successfully.',
		successSavingOffer: 'The offer was saved successfully.',
		failedSavingOffer: 'Failed to save the offer.',
		successSubmittedOffer: "Successfully submitted offer",
		successSubmittedRecognition: 'Successfully submitted recognition',
		failedSubmittedOffer: "Failed offer submission",
		successSubmittedSectorPresentation: "Successfully submitted Presentation",
		successfullyAddOfferToFavorites: 'Successfully added to saved offers.',
		successfullyRemovedOfferFromFavorites: 'Successfully removed from saved offers.',
		successfullyAddSectorToFavorites: "Successfully added to saved sector presentations.",
		successfullyRemovedSectorFavorites: 'Successfully removed from saved sector presentations.',
		successReportAProblem: "The problem was successfully reported.",
		failedSavingSector: "Failed to save the presentation.",
		successSavingSector: "The presentation was saved successfully.",
		failedSubmittedSector: "Failed to submit the presentation.",
		surveySuccessfullySubmitted: "Survey successfully submitted",
		errorSubmittingSurvey: "Error submitting survey",
		surveyNotCompleted: "Survey not completed",
		successPromoted: 'The project was successfully promoted.',
		successfullyAskedQuestion: 'The question was sent successfully. We will reply to you soon.',
		acceptedPromotion: 'Your project has been accepted for promotion and added to the queue. You will be notified when it is scheduled to appear on the Homepage.',
		success: 'Success!',
		reportAProblem: "Report a problem",
		reportAProblemDescription: "Please describe the issue encountered. Our team will review it as soon as possible.",
		topic: "Topic",
		topicPlaceholder: "Select topic (Bug, Incorrect info, etc.)",
		topicIdeaPlaceholder: "Select topic",
		description: "Description",
		descriptionPlaceholder: "Tell us more",
		screenshotOptional: "Screenshot (Optional)",
		yourEmail: "Your Email",
		yourEmailPlaceholder: "Enter your email address",
		successfullyDownloadedFile: "The file was successfully downloaded.",
		downloadingFile: "The file is downloading. Please wait.",
		surveyAlreadyFilled: "You have already filled out this survey. Stay tuned for more!",
		formEmptyWarning: 'Please enter a description of the problem.',
		successSavingRecognition: 'The recognition was saved successfully.',
		failedSubmittedRecognition: "Failed to submit the recognition.",
		failedLoadingExactRecognition: "Failed to load the recognition details.",
		recognitionWithSameNameExists: "A recognition with the same name already exists. Please choose a different name.",
		successChangedCountry: "Successfully changed country",
		errorChangedCountry: "Failed to change country",
		successfullyRemovedRecognitionFromFavorites: 'Successfully removed from saved recognitions.',
		successfullyAddRecognitionToFavorites: 'Successfully added to saved recognitions.',
		failedSavingRecognition: "Failed to save the recognition.",
		suggestModification: "Suggest Modification",
		suggestModificationDescription: "Do you have a suggestions? Please describe your idea and the GOP team will address your suggestion as soon as possible.",
		attachments: 'Attachments',
		inputErrorMessage: "Description is too long, please shorten it and try again.",
		fileErrorMessage: "One of the files you try to upload is too big. Please upload a smaller file and try again."
	},
	[LANGUAGE.de.short]: {
		statuses: {
			"1": "Neue Einreichungen",
			"2": "Zugewiesen",
			"3": "Unter Überprüfung",
			"4": "CM-Validierung",
			"5": "RO-Zulassung",
			"7": "Bereit zur Veröffentlichung",
			"8": "Veröffentlicht"
		},
		maxDraftStories: 'Sie haben das Maximum von 25 Stories-Entwürfen erreicht.',
		emailExists: 'E-Mail-Adresse bereits vorhanden',
		maxArchivedStories: 'Sie haben das Maximum von 25 archivierten Geschichten erreicht.',
		loginFailed: "Falsche email oder passwort",
		serverError: "Es gab einen fehler. Bitte versuchen sie es später erneut oder senden sie uns feedback.",
		draftSuccessfulSaved: "Das projekt wird gespeichert.",
		addToSaved: "Das Projekt wurde erfolgreich gespeichert.",
		failedAddToSaved: "Das Projekt konnte nicht zu den gespeicherten Projekten hinzugefügt werden.",
		removeFromSaved: "Das Projekt wurde erfolgreich entfernt.",
		failedToRemoveFromSavedProjects: "Das Projekt konnte nicht aus den gespeicherten Projekten entfernt werden.",
		successfullyDownload: "Das projekt wurde erfolgreich heruntergeladen.",
		successfullyReportedProblem: "Der Bericht wurde erfolgreich gesendet.",
		successfullySharedIdea: "Die Nachricht wurde erfolgreich übermittelt.",
		reportIdea: "Berichtsidee",
		reportAIdeaDescription: 'Bitte beschreiben Sie Ihre Idee. Unser Team wird sie schnellstmöglich prüfen.',
		successfullyValidated: "Das projekt ist validiert in ",
		successfullyCopyToClipboard: "Projektinhalt wurde erfolgreich kopiert",
		failedCopyToClipboard: "Fehler beim Kopieren des Projektinhalts in die Zwischenablage",
		newProjectStep: "Das projekt ist jetzt im status -",
		projectWaitingForApproval: "Ihr projekt wartet auf ihre genehmigung.",
		projectPublished: "Ihr projekt wurde veröffentlicht.",
		successSubmit: "Das projekt wird eingereicht.",
		denialMessage: "Das projekt wird erfolgreich abgelehnt.",
		approveProject: "Das projekt ist erfolgreich genehmigt.",
		reportAProblemValidation: "Sie haben nichts geschrieben. Bitte schreiben Sie eine Nachricht, bevor Sie sie senden.",
		reportAProblemPlaceholder: "Schreibe deine Nachricht hier...",
		reportAProblemSend: "Senden",
		reportAProblemSending: "Senden...",
		error: 'Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.',
		successUnarchived: 'Das Projekt wurde erfolgreich dearchiviert.',
		successInvalidate: 'Das Projekt wurde erfolgreich ungültig gemacht.',
		youDoNotHavePermissions: 'Sie sind nicht berechtigt, Projekte mit dem Status „Entwürfe“ zu dearchivieren.',
		reload: 'Anwendungsversion erfolgreich aktualisiert.',
		successBackToDraft: "Erfolgreich zu Projektentwürfen zurückgekehrt.",
		successUnpublished: "Das Projekt wurde erfolgreich unveröffentlicht",
		successDeleted: "Das Projekt wurde erfolgreich gelöscht",
		successDeletedOffer: "Angebot erfolgreich gelöscht",
		successDeletedRecognition: "Anerkennung erfolgreich gelöscht",
		successDeletedSector: "Sektorpräsentation erfolgreich gelöscht",
		successArchiveOffer: "Angebot erfolgreich archiviert",
		successArchiveRecognition: "Anerkennung erfolgreich archiviert",
		successUnArchiveOffer: "Angebot erfolgreich dearchiviert",
		successUnArchiveRecognition: "Anerkennung erfolgreich dearchiviert",
		successArchiveSector: "Erfolgreich archivierte Branchenpräsentation",
		successUnArchiveSector: "Sektorpräsentation erfolgreich dearchiviert",
		projectStepWasChanged: "Projektschritt wurde geändert",
		projectCannotBePreviewedBecauseValidations: "Das Projekt kann nicht in der Vorschau angezeigt werden, da einige der Validierungen nicht bestanden werden",
		emailSuccesfullyResent: "Sie haben erfolgreich eine E-Mail für das Projekt erneut gesendet",
		projectSuccessfullyAssigned: 'Projekt erfolgreich zugewiesen',
		failedToResendEmail: "Es konnte keine E-Mail für das Projekt mit der ID erneut gesendet werden",
		successArchived: 'Das Projekt wurde erfolgreich archiviert.',
		successUploadImage: `Das Bild wurde erfolgreich hochgeladen.`,
		successUpdatedNotificationOrder: 'Die Bestellung wurde erfolgreich aktualisiert.',
		successSavingOffer: 'Das Angebot wurde erfolgreich gespeichert.',
		failedSavingOffer: 'Fehler beim Speichern des Angebots.',
		successSubmittedOffer: "Angebot erfolgreich abgegeben",
		successSubmittedRecognition: "Anerkennung erfolgreich übermittelt",
		failedSubmittedOffer: "Angebotseinreichung fehlgeschlagen",
		successSubmittedSectorPresentation: "Präsentation erfolgreich eingereicht",
		successfullyAddOfferToFavorites: 'Erfolgreich zu den gespeicherten Angeboten hinzugefügt.',
		successfullyRemovedOfferFromFavorites: 'Erfolgreich aus den gespeicherten Angeboten entfernt.',
		successfullyAddSectorToFavorites: "Erfolgreich zu gespeicherten Sektorpräsentationen hinzugefügt.",
		successfullyRemovedSectorFavorites: 'Erfolgreich aus gespeicherten Sektorpräsentationen entfernt.',
		successReportAProblem: "Das Problem wurde erfolgreich gemeldet.",
		failedSavingSector: "Fehler beim Speichern der Präsentation.",
		successSavingSector: "Die Präsentation wurde erfolgreich gespeichert.",
		failedSubmittedSector: "Fehler beim Einreichen der Präsentation.",
		surveySuccessfullySubmitted: "Umfrage erfolgreich eingereicht",
		errorSubmittingSurvey: "Fehler beim Einreichen der Umfrage",
		surveyNotCompleted: "Umfrage nicht abgeschlossen",
		successPromoted: 'Das Projekt wurde erfolgreich gefördert.',
		successfullyAskedQuestion: 'Die Frage wurde erfolgreich gesendet. Wir werden Ihnen in Kürze antworten.',
		acceptedPromotion: 'Ihr Projekt wurde zur Bewerbung angenommen und der Warteschlange hinzugefügt. Sie werden benachrichtigt, sobald es auf der Startseite erscheint.',
		success: 'Erfolg!',
		reportAProblem: "Ein Problem melden",
		reportAProblemDescription: "Bitte beschreiben Sie das aufgetretene Problem. Unser Team wird es so schnell wie möglich überprüfen.",
		topic: "Thema",
		topicPlaceholder: "Thema auswählen (Fehler, falsche Informationen usw.)",
		topicIdeaPlaceholder: "Thema auswählen",
		description: "Beschreibung",
		descriptionPlaceholder: "Erzählen Sie uns mehr",
		screenshotOptional: "Screenshot (optional)",
		yourEmail: "Ihre E-Mail",
		yourEmailPlaceholder: "Geben Sie Ihre E-Mail-Adresse ein",
		successfullyDownloadedFile: "Die Datei wurde erfolgreich heruntergeladen.",
		downloadingFile: "Die Datei wird heruntergeladen. Bitte warten.",
		formEmptyWarning: 'Bitte geben Sie eine Beschreibung des Problems ein',
		surveyAlreadyFilled: "Sie haben diese Umfrage bereits ausgefüllt. Bleiben Sie dran für mehr!",
		successSavingRecognition: 'Die Anerkennung wurde erfolgreich gespeichert.',
		failedSubmittedRecognition: "Fehler beim Einreichen der Anerkennung.",
		failedLoadingExactRecognition: "Fehler beim Laden der Anerkennungsdetails.",
		recognitionWithSameNameExists: "Eine Anerkennung mit demselben Namen existiert bereits. Bitte wählen Sie einen anderen Namen.",
		successChangedCountry: "Land erfolgreich geändert",
		errorChangedCountry: "Fehler beim Ändern des Landes",
		successfullyRemovedRecognitionFromFavorites: "Erfolgreich aus den gespeicherten Anerkennungen entfernt.",
		successfullyAddRecognitionToFavorites: "Erfolgreich zu den gespeicherten Anerkennungen hinzugefügt.",
		failedSavingRecognition: "Fehler beim Speichern der Anerkennung.",
		suggestModification: "Änderung vorschlagen",
		suggestModificationDescription: "Haben Sie Vorschläge? Bitte beschreiben Sie Ihre Idee und das GOP-Team wird Ihren Vorschlag so schnell wie möglich bearbeiten.",
		attachments: 'Anhänge',
		inputErrorMessage: "Beschreibung ist zu lang, bitte kürzen Sie sie und versuchen Sie es erneut.",
		fileErrorMessage: "Eine der Dateien, die Sie hochzuladen versuchen, ist zu groß. Bitte laden Sie eine kleinere Datei hoch und versuchen Sie es erneut."
	},
	[LANGUAGE.fr.short]: {
		statuses: {
			"1": "Nouvelles soumissions",
			"2": "Attribué",
			"3": "En cours de révision",
			"4": "Validation CM",
			"5": "Approbation RO",
			"7": "Prêt à publier",
			"8": "Publié"
		},
		maxDraftStories: `Vous avez atteint le maximum de 25 brouillons d'histoires.`,
		emailExists: 'L\'adresse e-mail existe déjà.',
		maxArchivedStories: 'Vous avez atteint le maximum de 25 histoires archivées.',
		loginFailed: "Email ou mot de passe incorrect",
		serverError: "Il y avait une erreur. Veuillez réessayer plus tard ou envoyez-nous vos commentaires.",
		draftSuccessfulSaved: "Le projet est enregistré.",
		addToSaved: "Le projet a été enregistré avec succès.",
		failedAddToSaved: "Échec de l'ajout du projet aux projets enregistrés.",
		removeFromSaved: "Le projet a été supprimé avec succès.",
		successfullyCopyToClipboard: "Le contenu du projet a été copié avec succès",
		failedCopyToClipboard: "Échec de la copie du contenu du projet dans le presse-papiers",
		failedToRemoveFromSavedProjects: "Échec de la suppression du projet des projets enregistrés.",
		successfullyDownload: "Le projet est téléchargé avec succès.",
		successfullyReportedProblem: "Le rapport a été envoyé avec succès.",
		successfullySharedIdea: "L'idée a été envoyée avec succès.",
		reportIdea: "Idée de rapport",
		reportAIdeaDescription: 'Veuillez décrire votre idée. Notre équipe l\'examinera dans les plus brefs délais.',
		successfullyValidated: "Le projet est validé en ",
		newProjectStep: "Le projet est maintenant en statut -",
		projectWaitingForApproval: "Votre projet attend votre approbation.",
		projectPublished: "Votre projet a été publié.",
		successSubmit: "Le projet est déposé.",
		denialMessage: "Le projet est refusé avec succès.",
		approveProject: "Le projet est approuvé avec succès.",
		reportAProblemValidation: "Vous n'avez rien écrit. Veuillez écrire un message avant d'envoyer.",
		reportAProblemPlaceholder: "Ecrivez votre message ici...",
		reportAProblemSend: "Envoyer",
		reportAProblemSending: "Envoi en cours...",
		error: 'Quelque chose s\'est mal passé. Veuillez réessayer plus tard.',
		successUnarchived: 'Le projet a été désarchivé avec succès.',
		successInvalidate: 'Le projet a été invalidé avec succès.',
		youDoNotHavePermissions: 'Vous n\'êtes pas autorisé à désarchiver les projets dont le statut était Brouillons.',
		reload: 'Version de l\'application mise à jour avec succès.',
		successBackToDraft: "Retour réussi à l'ébauche de projets.",
		successUnpublished: "Le projet a été inédit avec succès",
		successDeleted: "Le projet a été supprimé avec succès",
		successDeletedRecognition: "Reconnaissance supprimée avec succès",
		successDeletedOffer: "Offre supprimée avec succès",
		successDeletedSector: "Présentation du secteur supprimée avec succès",
		successUnArchiveOffer: "Offre désarchivée avec succès",
		successUnArchiveRecognition: "Reconnaissance désarchivée avec succès",
		successArchiveOffer: "Offre archivée avec succès",
		successArchiveRecognition: "Reconnaissance archivée avec succès",
		successArchiveSector: "Présentation sectorielle archivée avec succès",
		successUnArchiveSector: "Présentation sectorielle désarchivée avec succès",
		projectStepWasChanged: "L'étape du projet a été modifiée",
		projectCannotBePreviewedBecauseValidations: "Le projet ne peut pas être prévisualisé car certaines validations ont échoué",
		emailSuccesfullyResent: "Vous avez renvoyé avec succès un e-mail pour le projet",
		projectSuccessfullyAssigned: 'Projet attribué avec succès',
		failedToResendEmail: "Échec du renvoi d'un e-mail pour le projet avec identifiant",
		successArchived: 'Le projet a été archivé avec succès.',
		successUploadImage: `L'image a été téléchargée avec succès.`,
		successUpdatedNotificationOrder: 'La commande a été mise à jour avec succès.',
		successSavingOffer: 'L\'offre a été enregistrée avec succès.',
		failedSavingOffer: 'Échec de l\'enregistrement de l\'offre.',
		successSubmittedOffer: "Offre soumise avec succès",
		successSubmittedRecognition: "Reconnaissance soumise avec succès",
		failedSubmittedOffer: "Échec de la soumission de l'offre",
		successSubmittedSectorPresentation: "Présentation soumise avec succès",
		successfullyAddOfferToFavorites: 'Ajouté avec succès aux offres enregistrées.',
		successfullyRemovedOfferFromFavorites: 'Supprimé avec succès des offres enregistrées.',
		successfullyAddSectorToFavorites: "Ajouté avec succès aux présentations de secteurs enregistrées.",
		successfullyRemovedSectorFavorites: 'Supprimé avec succès des présentations de secteurs enregistrées.',
		successReportAProblem: "Le problème a été signalé avec succès.",
		failedSavingSector: "Échec de l'enregistrement de la présentation.",
		successSavingSector: "La présentation a été enregistrée avec succès.",
		failedSubmittedSector: "Échec de la soumission de la présentation.",
		surveySuccessfullySubmitted: "Sondage soumis avec succès",
		errorSubmittingSurvey: "Erreur lors de la soumission de l'enquête",
		surveyNotCompleted: "Enquête non terminée",
		successPromoted: 'Le projet a été promu avec succès.',
		successfullyAskedQuestion: 'Votre question a été envoyée avec succès. Nous vous répondrons prochainement.',
		acceptedPromotion: 'Votre projet a été accepté pour la promotion et ajouté à la file d\'attente. Vous serez averti lorsqu\'il sera publié sur la page d\'accueil.',
		success: 'Succès!',
		reportAProblem: "Signaler un problème",
		reportAProblemDescription: "Veuillez décrire le problème rencontré. Notre équipe l'examinera dès que possible.",
		topic: "Sujet",
		topicPlaceholder: "Sélectionnez le sujet (bug, informations incorrectes, etc.)",
		topicIdeaPlaceholder: "Sélectionnez un sujet",
		description: "Description",
		descriptionPlaceholder: "Dites-nous en plus",
		screenshotOptional: "Capture d'écran (facultatif)",
		yourEmail: "Votre e-mail",
		yourEmailPlaceholder: "Entrez votre adresse e-mail",
		successfullyDownloadedFile: "Le fichier a été téléchargé avec succès.",
		downloadingFile: "Le téléchargement du fichier est en cours. Veuillez patienter.",
		surveyAlreadyFilled: "Vous avez déjà rempli ce sondage. Restez à l'écoute pour plus!",
		formEmptyWarning: 'Veuillez saisir une description du problème',
		successSavingRecognition: 'La reconnaissance a été enregistrée avec succès.',
		failedSubmittedRecognition: "Échec de la soumission de la reconnaissance.",
		failedLoadingExactRecognition: "Échec du chargement des détails de la reconnaissance.",
		recognitionWithSameNameExists: "Une reconnaissance portant le même nom existe déjà. Veuillez choisir un nom différent.",
		successChangedCountry: "Pays changé avec succès",
		errorChangedCountry: "Échec du changement de pays",
		successfullyRemovedRecognitionFromFavorites: "Retiré avec succès des reconnaissances enregistrées.",
		successfullyAddRecognitionToFavorites: "Ajouté avec succès aux reconnaissances enregistrées.",
		failedSavingRecognition: "Échec de l'enregistrement de la reconnaissance.",
		suggestModification: "Suggérer une modification",
		suggestModificationDescription: "Avez-vous des suggestions? Veuillez décrire votre idée et l'équipe GOP traitera votre suggestion dès que possible.",
		attachments: 'Pièces jointes',
		inputErrorMessage: "La description est trop longue, veuillez la raccourcir et réessayer.",
		fileErrorMessage: "L'un des fichiers que vous essayez de télécharger est trop volumineux. Veuillez télécharger un fichier plus petit et réessayer."
	},
	[LANGUAGE.it.short]: {
		statuses: {
			"1": "Nuovi Invii",
			"2": "Assegnato",
			"3": "In corso di revisione",
			"4": "Convalida CM",
			"5": "Approvazione RO",
			"7": "Pronto per la pubblicazione",
			"8": "Pubblicato"
		},
		maxDraftStories: 'Hai raggiunto il massimo di 25 bozze di storie.',
		emailExists: 'L\'email esiste già',
		maxArchivedStories: 'Hai raggiunto il massimo di 25 storie archiviate.',
		loginFailed: "Email o password sbagliate",
		serverError: "C'era un errore. Riprova più tardi o inviaci un feedback.",
		draftSuccessfulSaved: "Il progetto viene salvato.",
		addToSaved: "Il progetto è stato salvato con successo.",
		successfullyCopyToClipboard: "Il contenuto del progetto è stato copiato correttamente",
		failedCopyToClipboard: "Impossibile copiare il contenuto del progetto negli appunti",
		failedAddToSaved: "Impossibile aggiungere il progetto ai progetti salvati.",
		removeFromSaved: "Il progetto è stato rimosso con successo.",
		failedToRemoveFromSavedProjects: "Impossibile rimuovere il progetto dai progetti salvati.",
		successfullyDownload: "Il progetto è stato scaricato correttamente.",
		successfullyReportedProblem: "Il rapporto è stato inviato con successo.",
		successfullySharedIdea: "L'idea è stata inviata con successo.",
		reportIdea: "Idea di report",
		reportAIdeaDescription: 'Descrivici l\'idea. Il nostro team la esaminerà il prima possibile.',
		successfullyValidated: "Il progetto è validato in ",
		newProjectStep: "Il progetto è ora in stato -",
		projectWaitingForApproval: "Il tuo progetto è in attesa della tua approvazione.",
		projectPublished: "Il tuo progetto è stato pubblicato.",
		successSubmit: "Il progetto è presentato.",
		denialMessage: "Il progetto è stato respinto con successo.",
		approveProject: "Il progetto viene approvato con successo.",
		reportAProblemValidation: "Non hai scritto nulla. Si prega di scrivere un messaggio prima di inviare.",
		reportAProblemPlaceholder: "Scrivi il tuo messaggio qui ...",
		reportAProblemSend: "Inviare",
		reportAProblemSending: "Invio ...",
		error: 'Qualcosa è andato storto. Per favore riprova più tardi.',
		successUnarchived: 'Il progetto è stato disarchiviato correttamente.',
		successInvalidate: 'Il progetto è stato invalidato correttamente.',
		youDoNotHavePermissions: 'Non disponi dell\'autorizzazione per annullare l\'archiviazione di progetti con stato Bozze.',
		reload: 'Versione dell\'applicazione aggiornata correttamente.',
		successBackToDraft: "Ritornato con successo alle bozze dei progetti.",
		successUnpublished: "La pubblicazione del progetto è stata annullata con successo",
		successDeleted: "Il progetto è stato eliminato con successo",
		successDeletedOffer: "Offerta eliminata correttamente",
		successDeletedRecognition: "Riconoscimento eliminato con successo",
		successDeletedSector: "Presentazione del settore eliminata correttamente",
		successUnArchiveOffer: "Offerta annullata con successo",
		successUnArchiveRecognition: "Riconoscimento ripristinato dall'archivio con successo",
		successArchiveOffer: "Offerta archiviata con successo",
		successArchiveRecognition: "Riconoscimento archiviato con successo",
		successUnArchiveSector: "Presentazione del settore annullata correttamente",
		successArchiveSector: "Presentazione del settore archiviata con successo",
		projectStepWasChanged: "La fase del progetto è stata modificata",
		projectCannotBePreviewedBecauseValidations: "Non è possibile visualizzare l'anteprima del progetto perché alcune convalide non vengono superate",
		emailSuccesfullyResent: "Hai inviato nuovamente con successo un'e-mail per il progetto",
		projectSuccessfullyAssigned: 'Progetto assegnato con successo',
		failedToResendEmail: "Impossibile inviare nuovamente un'e-mail per il progetto con ID",
		successArchived: 'Il progetto è stato archiviato con successo.',
		successUploadImage: `L'immagine è stata caricata con successo.`,
		successUpdatedNotificationOrder: 'L\'ordine è stato aggiornato con successo.',
		successSavingOffer: 'L\'offerta è stata salvata con successo.',
		failedSavingOffer: 'Impossibile salvare l\'offerta.',
		successSubmittedOffer: "Offerta inviata con successo",
		successSubmittedRecognition: "Reconnaissance soumise avec succès",
		failedSubmittedOffer: "Invio dell'offerta non riuscita",
		successSubmittedSectorPresentation: "Presentazione inviata correttamente",
		successfullyAddOfferToFavorites: 'Aggiunto con successo alle offerte salvate.',
		successfullyRemovedOfferFromFavorites: 'Rimosso con successo dalle offerte salvate.',
		successfullyAddSectorToFavorites: "Aggiunto con successo alle presentazioni di settore salvate.",
		successfullyRemovedSectorFavorites: 'Rimosso con successo dalle presentazioni dei settori salvati.',
		successReportAProblem: "Il problema è stato segnalato con successo.",
		failedSavingSector: "Impossibile salvare la presentazione.",
		successSavingSector: "La presentazione è stata salvata con successo.",
		failedSubmittedSector: "Invio della presentazione non riuscito.",
		surveySuccessfullySubmitted: "Sondaggio inviato con successo",
		errorSubmittingSurvey: "Errore durante l'invio del sondaggio",
		surveyNotCompleted: "Sondaggio non completato",
		successPromoted: 'Il progetto è stato promosso con successo.',
		successfullyAskedQuestion: 'La domanda è stata inviata correttamente. Ti risponderemo presto.',
		acceptedPromotion: 'Il tuo progetto è stato accettato per la promozione e aggiunto alla coda. Riceverai una notifica quando sarà pubblicato sulla Homepage.',
		success: 'Successo!',
		reportAProblem: "Segnala un problema",
		reportAProblemDescription: "Si prega di descrivere il problema riscontrato. Il nostro team lo esaminerà il prima possibile.",
		topic: "Argomento",
		topicPlaceholder: "Seleziona argomento (bug, informazioni errate, ecc.)",
		topicIdeaPlaceholder: "Seleziona l'argomento",
		description: "Descrizione",
		descriptionPlaceholder: "Raccontaci di più",
		successfullyDownloadedFile: "Il file è stato scaricato correttamente.",
		downloadingFile: "Il file è in fase di download. Attendi.",
		surveyAlreadyFilled: "Hai già compilato questo sondaggio. Rimanete sintonizzati per saperne di più!",
		formEmptyWarning: 'Inserisci una descrizione del problema',
		successSavingRecognition: 'Il riconoscimento è stato salvato con successo.',
		failedSubmittedRecognition: "Invio del riconoscimento non riuscito.",
		failedLoadingExactRecognition: "Caricamento dei dettagli del riconoscimento non riuscito.",
		recognitionWithSameNameExists: "Un riconoscimento con lo stesso nome esiste già. Scegli un nome diverso.",
		successChangedCountry: "Paese cambiato con successo",
		errorChangedCountry: "Errore durante il cambio del paese",
		successfullyRemovedRecognitionFromFavorites: "Rimosso con successo dai riconoscimenti salvati.",
		successfullyAddRecognitionToFavorites: "Aggiunto con successo ai riconoscimenti salvati.",
		failedSavingRecognition: "Impossibile salvare il riconoscimento.",
		suggestModification: "Suggerisci una modifica",
		suggestModificationDescription: "Hai dei suggerimenti? Descrivi la tua idea e il team GOP affronterà il tuo suggerimento il prima possibile.",
		attachments: 'Allegati',
		inputErrorMessage: "La descrizione è troppo lunga, accorciarla e riprovare.",
		fileErrorMessage: "Uno dei file che stai tentando di caricare è troppo grande. Carica un file più piccolo e riprova."
	},
	[LANGUAGE.ja.short]: {
		statuses: {
			"1": "新規提出",
			"2": "割り当て済み",
			"3": "審査中",
			"4": "CM検証",
			"5": "RO承認",
			"7": "公開の準備ができました",
			"8": "公開済み"
		},
		successfullyCopyToClipboard: "プロジェクトのコンテンツが正常にコピーされました",
		failedCopyToClipboard: "プロジェクト コンテンツをクリップボードにコピーできませんでした",
		maxDraftStories: 'ドラフト ストーリーの最大数 25 に達しました。',
		emailExists: 'そのメールアドレスはすでに存在します',
		maxArchivedStories: 'アーカイブ済みストーリーの最大数 25 に達しました。',
		loginFailed: "間違ったメールアドレスまたはパスワード",
		serverError: "エラーが発生しました。 後でもう一度試すか、フィードバックを送信してください。",
		draftSuccessfulSaved: "プロジェクトが保存されます。",
		addToSaved: "プロジェクトは正常に保存されました。",
		failedAddToSaved: "プロジェクトを保存済みプロジェクトに追加できませんでした。",
		removeFromSaved: "プロジェクトは正常に削除されました。",
		failedToRemoveFromSavedProjects: "保存済みプロジェクトからプロジェクトを削除できませんでした。",
		successfullyDownload: "プロジェクトが正常にダウンロードされました。",
		successfullyReportedProblem: "レポートは正常に送信されました。",
		successfullySharedIdea: "アイデアは正常に送信されました。",
		reportIdea: "レポートのアイデア",
		reportAIdeaDescription: 'アイデアの内容を説明してください。担当チームが速やかに検討いたします。',
		successfullyValidated: "プロジェクトはで検証されます ",
		newProjectStep: "プロジェクトは現在ステータスにあります-",
		projectWaitingForApproval: "あなたのプロジェクトはあなたの承認を待っています。",
		projectPublished: "プロジェクトが公開されました。",
		successSubmit: "プロジェクトが提出されます。",
		denialMessage: "プロジェクトは正常に拒否されました。",
		approveProject: "プロジェクトは正常に承認されました。",
		reportAProblemValidation: "あなたは何も書いていません。送信する前にメッセージを書いてください。",
		reportAProblemPlaceholder: "ここにあなたのメッセージを書く...",
		reportAProblemSend: "送信",
		reportAProblemSending: "送信...",
		error: 'エラーが発生しました。 後でもう一度やり直してください。',
		successUnarchived: 'プロジェクトは正常に解凍されました。',
		successInvalidate: 'プロジェクトは正常に無効化されました。',
		youDoNotHavePermissions: 'ステータスが下書きのプロジェクトをアーカイブ解除する権限がありません。',
		reload: 'アプリケーションのバージョンが正常に更新されました。',
		successBackToDraft: "無事にドラフトプロジェクトに戻りました。",
		successUnpublished: "プロジェクトは正常に非公開になりました",
		successDeleted: "プロジェクトは正常に削除されました",
		successDeletedOffer: "オファーが正常に削除されました",
		successDeletedRecognition: "表彰の削除が正常に完了しました",
		successDeletedSector: "セクタープレゼンテーションが正常に削除されました",
		successUnArchiveOffer: "オファーのアーカイブが正常に解除されました",
		successUnArchiveRecognition: "表彰のアーカイブ解除が正常に完了しました",
		successArchiveOffer: "オファーが正常にアーカイブされました",
		successArchiveRecognition: "表彰のアーカイブが正常に完了しました",
		successArchiveSector: "セクタープレゼンテーションが正常にアーカイブされました",
		successUnArchiveSector: "セクター プレゼンテーションが正常に解凍されました",
		projectStepWasChanged: "プロジェクトステップが変更されました",
		projectCannotBePreviewedBecauseValidations: "一部の検証に合格しないため、プロジェクトをプレビューできません",
		emailSuccesfullyResent: "プロジェクトのメールが正常に再送信されました",
		projectSuccessfullyAssigned: 'プロジェクトが正常に割り当てられました',
		failedToResendEmail: "ID を含むプロジェクトの電子メールの再送信に失敗しました",
		successArchived: 'プロジェクトは正常にアーカイブされました.',
		successUploadImage: `画像は正常にアップロードされました。`,
		successUpdatedNotificationOrder: '注文は正常に更新されました。',
		successSavingOffer: 'オファーは正常に保存されました。',
		failedSavingOffer: 'オファーの保存に失敗しました。',
		successSubmittedOffer: "オファーが正常に送信されました",
		successSubmittedRecognition: "表彰の送信が正常に完了しました",
		failedSubmittedOffer: "オファーの送信に失敗しました",
		successSubmittedSectorPresentation: "プレゼンテーションの提出が完了しました",
		successfullyAddOfferToFavorites: '保存されたオファーに正常に追加されました。',
		successfullyRemovedOfferFromFavorites: '保存されたオファーから正常に削除されました。',
		successfullyAddSectorToFavorites: "保存されたセクター プレゼンテーションに正常に追加されました。",
		successfullyRemovedSectorFavorites: '保存されたセクター プレゼンテーションから正常に削除されました。',
		successReportAProblem: "問題は正常に報告されました。",
		failedSavingSector: "プレゼンテーションの保存に失敗しました。",
		successSavingSector: "プレゼンテーションは正常に保存されました。",
		failedSubmittedSector: "プレゼンテーションの提出に失敗しました。",
		surveySuccessfullySubmitted: "調査が正常に提出されました",
		errorSubmittingSurvey: "調査の提出中にエラーが発生しました",
		surveyNotCompleted: "調査が完了していません",
		successPromoted: 'プロジェクトは成功裏に推進されました。',
		successfullyAskedQuestion: '質問は送信されました。すぐに返信いたします。',
		acceptedPromotion: 'プロジェクトはプロモーションに承認され、キューに追加されました。ホームページへの掲載予定が決まりましたら、お知らせいたします。',
		success: '成功！',
		reportAProblem: "問題を報告する",
		reportAProblemDescription: "発生した問題を説明してください。私たちのチームはできるだけ早くそれを確認します。",
		topic: "トピック",
		topicPlaceholder: "トピックを選択 (バグ、不正確な情報など)",
		topicIdeaPlaceholder: "トピックを選択",
		description: "説明",
		descriptionPlaceholder: "詳細を教えてください",
		screenshotOptional: "スクリーンショット (オプション)",
		yourEmail: "あなたのメール",
		yourEmailPlaceholder: "メールアドレスを入力してください",
		successfullyDownloadedFile: "ファイルのダウンロードに成功しました。",
		downloadingFile: "ファイルをダウンロード中です。しばらくお待ちください。",
		surveyAlreadyFilled: "この調査はすでに記入しています。詳細については、引き続きご覧ください！",
		formEmptyWarning: '問題の説明を入力してください',
		successSavingRecognition: '認識は正常に保存されました。',
		failedSubmittedRecognition: "認識の提出に失敗しました。",
		failedLoadingExactRecognition: "認識の詳細の読み込みに失敗しました。",
		recognitionWithSameNameExists: "同じ名前の認識がすでに存在します。別の名前を選択してください。",
		successChangedCountry: "国が正常に変更されました",
		errorChangedCountry: "国の変更に失敗しました",
		successfullyRemovedRecognitionFromFavorites: "保存済みの表彰から正常に削除されました。",
		successfullyAddRecognitionToFavorites: "保存済みの表彰に正常に追加されました。",
		failedSavingRecognition: "認識の保存に失敗しました。",
		suggestModification: "変更を提案する",
		suggestModificationDescription: "提案がありますか？アイデアを説明してください。GOPチームができるだけ早く提案を処理します。",
		attachments: "添付ファイル",
		inputErrorMessage: "説明が長すぎます。短くして、もう一度やり直してください。",
		fileErrorMessage: "アップロードしようとしているファイルの 1 つが大きすぎます。小さいファイルをアップロードして、もう一度やり直してください。"
	},
	[LANGUAGE.es.short]: {
		statuses: {
			"1": "Nuevas Presentaciones",
			"2": "Asignado",
			"3": "En Revisión",
			"4": "Validación CM",
			"5": "Aprobación RO",
			"7": "Listo para Publicar",
			"8": "Publicado"
		},
		maxDraftStories: 'Has alcanzado el máximo de 25 historias en borrador.',
		emailExists: 'El correo electrónico ya existe',
		maxArchivedStories: 'Has alcanzado el máximo de 25 historias archivadas.',
		loginFailed: "Correo electrónico o contraseña incorrectos",
		serverError: "Hubo un error. Por favor, inténtalo de nuevo más tarde o envíanos tus comentarios.",
		draftSuccessfulSaved: "El proyecto se ha guardado.",
		addToSaved: "El proyecto se ha guardado correctamente.",
		failedAddToSaved: "No se pudo agregar el proyecto a Proyectos Guardados.",
		removeFromSaved: "El proyecto se ha eliminado correctamente.",
		failedToRemoveFromSavedProjects: "No se pudo eliminar el proyecto de Proyectos Guardados.",
		successfullyDownload: "El proyecto se ha descargado correctamente.",
		successfullyReportedProblem: "El informe se ha enviado correctamente.",
		successfullySharedIdea: "La idea se ha enviado correctamente.",
		reportIdea: "Idea para reportar",
		reportAIdeaDescription: 'Por favor, describa la idea. Nuestro equipo la revisará lo antes posible.',
		successfullyValidated: "El proyecto está validado en ",
		newProjectStep: "El proyecto ahora está en estado -",
		projectWaitingForApproval: "Tu proyecto está esperando tu aprobación.",
		projectPublished: "Tu proyecto ha sido publicado.",
		successSubmit: "El proyecto se ha enviado.",
		denialMessage: "El proyecto ha sido rechazado con éxito.",
		approveProject: "El proyecto ha sido aprobado con éxito.",
		reportAProblemValidation: "No has escrito nada. Por favor, escribe un mensaje antes de enviar.",
		reportAProblemPlaceholder: "Escribe tu mensaje aquí...",
		reportAProblemSend: "Enviar",
		reportAProblemSending: "Enviando...",
		error: 'Algo salió mal. Por favor, inténtalo de nuevo más tarde.',
		successUnarchived: 'El proyecto se ha desarchivado correctamente.',
		successInvalidate: 'El proyecto se ha invalidado correctamente.',
		youDoNotHavePermissions: 'No tienes permiso para desarchivar proyectos que estaban en estado Borradores.',
		reload: 'Versión de la aplicación actualizada correctamente.',
		successBackToDraft: "Regreso exitoso a los proyectos en borrador.",
		successUnpublished: "El proyecto ha sido desaprobado con éxito",
		successDeleted: "El proyecto ha sido eliminado con éxito",
		successDeletedOffer: "Oferta eliminada con éxito",
		successDeletedRecognition: "Reconocimiento eliminado con éxito",
		successDeletedSector: "Presentación del sector eliminada con éxito",
		successUnArchiveOffer: "Oferta desarchivada con éxito",
		successUnArchiveRecognition: "Reconocimiento desarchivado con éxito",
		successArchiveOffer: "Oferta archivada con éxito",
		successArchiveRecognition: "Reconocimiento archivado con éxito",
		successArchiveSector: "Presentación del sector archivada con éxito",
		successUnArchiveSector: "Presentación del sector desarchivada con éxito",
		projectStepWasChanged: "El paso del proyecto ha sido cambiado",
		projectCannotBePreviewedBecauseValidations: "El proyecto no se puede previsualizar porque algunas validaciones no se cumplen",
		emailSuccesfullyResent: "Has reenviado correctamente un correo electrónico para el proyecto",
		projectSuccessfullyAssigned: 'Proyecto asignado con éxito',
		failedToResendEmail: "No se pudo reenviar un correo electrónico para el proyecto con ID",
		successArchived: 'El proyecto se ha archivado correctamente.',
		successUploadImage: `La imagen se ha cargado correctamente.`,
		successUpdatedNotificationOrder: 'El orden se ha actualizado correctamente.',
		successSavingOffer: 'La oferta se ha guardado correctamente.',
		failedSavingOffer: 'No se pudo guardar la oferta.',
		successSubmittedOffer: "Oferta enviada con éxito",
		successSubmittedRecognition: "Reconocimiento enviado con éxito",
		failedSubmittedOffer: "Error al enviar la oferta",
		successSubmittedSectorPresentation: "Presentación enviada correctamente",
		successfullyAddOfferToFavorites: 'Añadido correctamente a las ofertas guardadas.',
		successfullyRemovedOfferFromFavorites: 'Eliminado correctamente de las ofertas guardadas.',
		successfullyAddSectorToFavorites: "Añadido correctamente a las presentaciones de sector guardadas.",
		successfullyRemovedSectorFavorites: 'Eliminado correctamente de las presentaciones de sector guardadas.',
		successReportAProblem: "El problema se ha informado correctamente.",
		failedSavingSector: "No se pudo guardar la presentación.",
		successSavingSector: "La presentación se ha guardado correctamente.",
		failedSubmittedSector: "Error al enviar la presentación.",
		surveySuccessfullySubmitted: "Encuesta enviada con éxito",
		errorSubmittingSurvey: "Error al enviar la encuesta",
		surveyNotCompleted: "Encuesta no completada",
		successPromoted: 'El proyecto ha sido promovido con éxito.',
		successfullyAskedQuestion: 'La pregunta se ha enviado correctamente. Te responderemos pronto.',
		acceptedPromotion: 'Tu proyecto ha sido aceptado para promoción y añadido a la cola. Serás notificado cuando aparezca en la página de inicio.',
		success: '¡Éxito!',
		reportAProblem: "Informar un problema",
		reportAProblemDescription: "Por favor, describe el problema encontrado. Nuestro equipo lo revisará lo antes posible.",
		topic: "Tema",
		topicPlaceholder: "Selecciona un tema (error, información incorrecta, etc.)",
		topicIdeaPlaceholder: "Seleccione un tema",
		description: "Descripción",
		descriptionPlaceholder: "Cuéntanos más",
		screenshotOptional: "Captura de pantalla (opcional)",
		yourEmail: "Tu correo electrónico",
		yourEmailPlaceholder: "Ingresa tu dirección de correo electrónico",
		successfullyDownloadedFile: "El archivo se descargó correctamente.",
		downloadingFile: "El archivo se está descargando. Espere.",
		surveyAlreadyFilled: "Ya has completado esta encuesta. ¡Mantente atento para más!",
		formEmptyWarning: 'Por favor ingrese una descripción del problema',
		successSavingRecognition: 'El reconocimiento se ha guardado correctamente.',
		failedSubmittedRecognition: "Error al enviar el reconocimiento.",
		failedLoadingExactRecognition: "Error al cargar los detalles del reconocimiento.",
		recognitionWithSameNameExists: "Ya existe un reconocimiento con el mismo nombre. Por favor, elige un nombre diferente.",
		successChangedCountry: "País cambiado con éxito",
		errorChangedCountry: "Error al cambiar el país",
		successfullyRemovedRecognitionFromFavorites: "Eliminado con éxito de los reconocimientos guardados.",
		successfullyAddRecognitionToFavorites: "Añadido con éxito a los reconocimientos guardados.",
		failedSavingRecognition: "Error al guardar el reconocimiento.",
		suggestModification: "Sugerir una modificación",
		suggestModificationDescription: "¿Tienes sugerencias? Por favor, describe tu idea y el equipo de GOP procesará tu sugerencia lo antes posible.",
		attachments: "Archivos adjuntos",
		inputErrorMessage: "La descripción es demasiado larga, por favor acórtala e inténtalo de nuevo.",
		fileErrorMessage: "Uno de los archivos que estás intentando subir es demasiado grande. Por favor, sube un archivo más pequeño e inténtalo de nuevo."
	},
}
